import { createContext } from 'react'

export const BrandingContext = createContext({})
